// TODO: This component should be refactored to coalesce with series/title detail components
// Would also be ideal to refactor the container->comp props to avoid unnecessary re-renders
// (i.e. Try and avoid passing objects and arrays down directly)
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { propType } from 'graphql-anywhere'
import { Background } from 'react-imgix'

import HOTSPOT_SLIDE_FRAGMENT from '../../../../graphql/fragments/hotspot-slide.gql'
import { appConfigPropType } from '../../player/utils/prop-types'
import {
  AUTOPLAY_TRAILER_DELAY_S,
  IMGIX_CROP_OPTIONS
} from '../../../constants'
import { getConfigValue } from '../../../utils/getConfigValue'
import GuestContentCTABox from './guest-content-cta-box'
import UserContentCTABox from './user-content-cta-box'
import Topgradient from '../../shared/top-gradient'
import AutoplayTrailerStream from '../../autoplay-trailer/autoplay-trailer-stream'
import rentalBadge from '../../../../images/rental-badge.svg'
import styles from './user-slide.css'

function UserSlide({
  className,
  isAuthenticated,
  onCtaClick,
  slide,
  appConfig,
  usableOnClick,
  isOnMyList,
  addToMyList,
  hasTopgradient,
  isGuestHome,
  isSlideSelected,
  isTrailerMuted,
  setTrailerMuted,
  onTrailerLoaded,
  onTrailerEnded,
  trailerAutoplayEnabled
}) {
  const slideWrapperRef = useRef(null)
  const [isOffscreen, setIsOffscreen] = useState(false)
  const title = slide.header || ''
  const brandLogo = slide.contentItem.brandOrDistributorLogo
  const guestHotspotImage = getConfigValue(appConfig?.values, 'GUEST_HOME_HOTSPOT_IMAGE')
  const backgroundImage = isGuestHome ? guestHotspotImage : slide.image
  const trailerId = slide.contentItem?.autoplayTrailerId

  useEffect(() => {
    if (!slideWrapperRef.current) {
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsOffscreen(!entry.isIntersecting)
      }
    )

    observer.observe(slideWrapperRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  // Render trailer only when available, autoplay is enabled,
  // this slide is selected, and the slide is still on screen.
  const renderTrailer = trailerId &&
    isSlideSelected &&
    !isGuestHome &&
    trailerAutoplayEnabled &&
    !isOffscreen
  const trailerContent = {
    id: trailerId,
    delaySeconds: AUTOPLAY_TRAILER_DELAY_S
  }

  return (
    <div
      ref={slideWrapperRef}
      className={classnames(styles.slideWrapper, className)}
    >
      {hasTopgradient && <Topgradient />}
      <div className={classnames({ [styles.sideGradient]: isGuestHome })} />
      <div className={classnames({ [styles.bottomGradient]: isGuestHome })} />
      {slide.contentItem.isRental && (
        <img className={styles.rentalBadge} src={rentalBadge} alt="Rental Content" />
      )}

      <div className={styles.imageWrapper}>
        {renderTrailer ? (
          <AutoplayTrailerStream
            content={trailerContent}
            image={slide.image}
            isMuted={isTrailerMuted}
            onMuteChange={setTrailerMuted}
            onTrailerLoaded={onTrailerLoaded}
            onTrailerEnded={onTrailerEnded}
          />
        ) : (
          <Background
            className={classnames(styles.image, isGuestHome && styles.imageInCenter)}
            type="img"
            src={backgroundImage}
            imgixParams={{
              crop: IMGIX_CROP_OPTIONS.HOTSPOT,
              fit: 'crop'
            }}
            precision={50}
          />
        )}
      </div>

      {isGuestHome ? (
        <GuestContentCTABox />
      ) : (
        <>
          <UserContentCTABox
            slide={slide}
            title={title}
            onCtaClick={onCtaClick}
            usableOnClick={usableOnClick}
            isAuthenticated={isAuthenticated}
            isRental={slide.contentItem.isRental}
            isOnMyList={isOnMyList}
            addToMyList={addToMyList}
          />

          <div className={styles.copyrightAndBrandLogo}>
            { brandLogo && <img className={styles.brandLogo} src={brandLogo} alt="content brand logo" /> }
            <p className={styles.copyright}>
              {slide.copyright}
            </p>
          </div>
        </>
      )}
    </div>
  )
}

UserSlide.propTypes = {
  slide: propType(HOTSPOT_SLIDE_FRAGMENT).isRequired,
  isOnMyList: PropTypes.bool.isRequired,
  addToMyList: PropTypes.func.isRequired,
  hasTopgradient: PropTypes.bool.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  usableOnClick: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  appConfig: appConfigPropType.isRequired,
  isGuestHome: PropTypes.bool.isRequired,
  className: PropTypes.string,
  isTrailerMuted: PropTypes.bool.isRequired,
  setTrailerMuted: PropTypes.func.isRequired,
  onTrailerLoaded: PropTypes.func.isRequired,
  onTrailerEnded: PropTypes.func.isRequired,
  isSlideSelected: PropTypes.bool.isRequired,
  trailerAutoplayEnabled: PropTypes.bool.isRequired
}

UserSlide.defaultProps = {
  className: null
}

export default UserSlide
